export const strToNumericStr = (numericString: string) => {
  return String(numericString).replace(/[^\d]/g, "");
};

export const formatInternationalPhoneNumber = (
  phoneNumber?: string | null
): string | undefined => {
  if (!phoneNumber) return undefined;
  const onlyDigitsAndPlus = phoneNumber.replace(/[^\d|+]/g, "");
  const isUsPhoneNumber = onlyDigitsAndPlus.match(/^\+1\d{10}$/);
  if (isUsPhoneNumber) {
    return onlyDigitsAndPlus.replace(
      /^\+1(\d{3})(\d{3})(\d{4})$/,
      "($1) $2-$3"
    );
  }
  return phoneNumber;
};

const SQFT_TO_ACRES = 43560;
export const ACRES_THRESHOLD_SQFT = 40000;

export const convertSqftToAcres = (sqft: number): number => {
  return sqft / SQFT_TO_ACRES;
};

export const convertAcresToSqft = (acres: number): number => {
  return acres * SQFT_TO_ACRES;
};
